import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import IntractionActionsList from '../../components/IntractionActionsList'
import StagesManager from '../../components/StagesManager'
import FixedView from '../../components/FixedView'

export default class NotebookHelp extends Component {

    state = {}

    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.fiexView?.hideView()
    }

    changePageSubMenu = (title) => {
        this.stageManager.changeStage(title)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.help = el} onClick={() => { this.helpView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('notebook.Help')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={(el) => (this.helpView = el)} nodeRef={this.help} xOffset={this.props.language == "fa" ? 205 : -10} bottomOffset={0} topOffset={0} maxWidth={260}  >
                    <div className="bg-white br-10 p-1 shadow-3">
                        <div className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}   >
                            <div className="mb-2">
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Help", icon: "/assets/icons/note/help/help.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Training", icon: "/assets/icons/note/help/train.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Updates", icon: "/assets/icons/note/help/update.svg" }} />
                            </div>
                            <div className="py-2" style={{ borderTop: "1px solid #eee" }}   >
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Help Docs improve", icon: "/assets/icons/note/help/docs.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Report abuse", icon: "/assets/icons/note/help/report.svg" }} />
                            </div>
                            <div className="py-2" style={{ borderTop: "1px solid #eee" }}  >
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Privacy Policy", icon: "/assets/icons/note/help/privacy.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Terms of Services", icon: "/assets/icons/note/help/privacy.svg" }} />
                            </div>
                            <div className="pt-2" style={{ borderTop: "1px solid #eee" }}  >
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Keyboard shortcuts", icon: "/assets/icons/note/help/keyboard.svg" }} />
                            </div>
                        </div>
                    </div>
                </FixedView>
            </>
        )
    }
}
